class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.js-back-in-stock-input');
    this.button = this.querySelector('.js-back-in-stock-button');
    this.init();
  }

  init() {
    if (!this.input || !this.button) return;

    this.input.addEventListener('keyup', (e) => {
      e.preventDefault();
      if (e.code === 'Enter') this.submit();
    });

    this.button.addEventListener('click', (e) => {
      this.submit();
    });
  }

  submit() {
    const variant = this.getAttribute('data-variant-id');

    if (!variant || this.input.value === '' || this.button.classList.contains('loading')) return;

    this.button.classList.add('loading');

    const email = this.input.value.trim();
    const key = 'test';
    const url = `https://a.klaviyo.com/api/v1/catalog/subscribe?a=${key}&email=${email}&variant=${variant}&platform=shopify`

    try {
      fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (!data.success) {
          this.error(data.errors[0]);
          return;
        }

        document.dispatchEvent(
          new CustomEvent('alert:show', { 
            detail: {
              data: {
                message: 'success',
                status: 'Success'
              }
            }
          })
        );
      })
      .catch((error) => {
        this.error(error);
      })
    } catch(error) {
      this.error(error);
    }
  }

  error(message) {
    if (!message) return;

    this.button.classList.remove('loading');

    document.dispatchEvent(
      new CustomEvent('alert:show', { 
        detail: {
          data: {
            message: message,
            status: 'Error'
          }
        }
      })
    );
  }
}

customElements.define('back-in-stock', BackInStock);
